const homeUrls = {
    appStatistics: {
        url: '/application/stats/appStatistics'
    },
    statsByMonth: {
        url: '/application/stats/statsByMonth'
    },
    statsByOffice: {
        url: '/application/stats/statsByOffice'
    },
    statsByDivision: {
        url: '/application/stats/statsByDivision'
    },
    statsByContestType: {
        url: '/application/stats/statsByContestType'
    }
};

export default homeUrls;
